module.exports = __webpack_public_path__ + "media/images/flags/eu-26c14270e73fb88da340e72320d304de.svg";